import { createContext } from "react";

export const Alert = createContext({
    open: false,
    autoHideDuration: 3000,
    onClose: ()=>null,
    severity: "",
    alertvalue: "",
    setAlert:()=>null
})